
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/sync",
      function () {
        return require("private-next-pages/examples/sync.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/sync"])
      });
    }
  